export default function () {
  return {
    liveSporters: [],
    activeConnections: new Map()
  }
}
